<template>
	<listado></listado>
</template>


<script>
import Listado from './components/listado/listado.vue'

export default {
	name: 'clientes',
	components: {
		'listado': Listado
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-clientes/vue/App.vue